import { api } from "./api";

export const aiRecommendations = api.injectEndpoints({
    endpoints: (builder) => ({
        getAiRecommendations: builder.query<any, void>({
            query: () => ({
                url: "/StudyRecommendations/StudyRecommendations",
                method: "GET"
            })
        })
    })
})

export const { useGetAiRecommendationsQuery, useLazyGetAiRecommendationsQuery } = aiRecommendations;